import ClientsPageLayout from 'container/ClientsPageLayout'

const Clients = () => <ClientsPageLayout />

export default Clients
